import { IInteriorDesignFilter } from '@features/cms/typescript';
const getFiltersArticlesFromUrl = (filters: IInteriorDesignFilter[], setFiltersState: (filters: IInteriorDesignFilter[]) => void) => {
  if (typeof window !== 'undefined') {
    const {
      search
    } = window.location;
    const params = new URLSearchParams(search);
    filters.forEach(filter => {
      const filterUrlValue = params.get(filter.type.toString());
      if (filterUrlValue && filterUrlValue.split('-').includes(filter.value)) {
        filter.isChecked = true;
      }
    });
    setFiltersState(filters);
  }
};
export default getFiltersArticlesFromUrl;